import getCheckoutItemViewsWithLoyaltyUpgradeAvailable from 'checkout/selectors/loyalty/getCheckoutItemViewsWithLoyaltyUpgradeAvailable'
import getHotelItemViews from 'checkout/selectors/view/itemViews/getHotelItemViews'
import getLoyaltyBenefitAvailability from 'loyalty/lib/determineLoyaltyBenefitAvailability'
import getLoyaltyStayUpgradeBenefit from 'loyalty/selectors/getLoyaltyStayUpgradeBenefit'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { createSelector } from 'reselect'

const getCanRedeemStayUpgradeLoyaltyBenefit = createSelector(
  (state: App.State) => getLoyaltyStayUpgradeBenefit(state),
  (state: App.State) => getCheckoutItemViewsWithLoyaltyUpgradeAvailable(state),
  (state: App.State) => getHotelItemViews(state),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (
    stayUpgradeBenefit,
    itemViewsWithLoyaltyUpgradeAvailable,
    hotelOfferViews,
    isCurrentRegionUserLoyaltyRegion,
  ): boolean => {
    if (
      !isCurrentRegionUserLoyaltyRegion ||
      !stayUpgradeBenefit ||
      !getLoyaltyBenefitAvailability(stayUpgradeBenefit)
    ) return false
    /**
     * Ideally `!!itemViewsWithLoyaltyUpgradeAvailable.length` should be accurate enough,
     * but we're not supporting multi accommodation items yet.
     * For that reason, we only enable the benefit section if there's only **one** accommodation item.
     */
    return hotelOfferViews.data.length === 1 && itemViewsWithLoyaltyUpgradeAvailable.length === 1
  },
)

export default getCanRedeemStayUpgradeLoyaltyBenefit
